//
// locales/vanilla/ka.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/ka.json';
import localeData from 'react-intl/locale-data/ka.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
